import React from "react";
import websiteData from '../data.json';
import { Row, Col } from 'react-bootstrap';
import SectionContainer from '../components/containers/section-container';
import CoverHeaderXs from '../components/header/cover-header-xs';
import AsideElement from '../components/aside/aside';
import BlockEntry from '../components/aside/blockentry';
import ReactGA from 'react-ga';

export const initGA = () => {
    /* console.log('Ga init'); */
     ReactGA.initialize('UA-90162173-1'); 
}

export const logPageView = () => {
    /* console.log(window.location.pathname); */
    ReactGA.set({ page: window.location.pathname });
    ReactGA.pageview(window.location.pathname);
}

export default class BlogPage extends React.Component {
        componentDidMount() {
        initGA();
        logPageView();
    }
    render() {
        const blogPage = websiteData.blogPage,
              dataCoverHeaderXs = blogPage.CoverHeaderXs[0],
              dataRecentPosts = blogPage.recentPosts,
              dataReadMore = blogPage.readMore;        
        return (
            <div id="page">
                <CoverHeaderXs backgroundImage={ dataCoverHeaderXs.headerBackgroundImage } headerSizeClass={ dataCoverHeaderXs.headerSizeClass } headerTitle={ dataCoverHeaderXs.headerTitle } headerSubTitle={ dataCoverHeaderXs.headerSubTitle }/>
                <div className="gtco-section blog">
                    <SectionContainer>
                        <Row>
                            <BlockEntry content={ this.props.blogEntries } readMore={ dataReadMore } />
                            <Col md={4}>
                                <AsideElement recentPosts={ dataRecentPosts } content={ this.props.blogEntries } />
                            </Col>                            
                        </Row>
                    </SectionContainer>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/blog-page.js